export default __webpack_public_path__ + "static/media/quadro-super-bonder.68e94f84.png";